import { NoteProperty } from "src/components";
import { ActionItemDetailDto, useEditActionItemNote } from "src/http";

interface Props {
  actionItem: ActionItemDetailDto;
}

const ActionItemNoteProperty = (props: Props) => {
  const { mutate: editActionItemNote, isLoading } = useEditActionItemNote();

  function handleSaveClicked(note: string) {
    editActionItemNote({
      actionItemGuid: props.actionItem.guid,
      note,
      planGuid: props.actionItem.teamPlanSection.planGuid,
    });
  }

  return (
    <NoteProperty
      note={props.actionItem.note}
      userCanEdit={props.actionItem.userCanEdit}
      disabled={isLoading}
      onSaveClicked={handleSaveClicked}
    />
  );
};

export { ActionItemNoteProperty };
